import moment from 'moment';
import { dateFormats, intervalOptions } from '~/utils';

export const intervals = {
  get custom() {
    return intervalOptions.custom;
  },

  get today() {
    return intervalOptions.today;
  },

  get yesterday() {
    return intervalOptions.yesterday;
  },

  get this_week() {
    return intervalOptions.this_week;
  },

  get this_week_to_date() {
    return intervalOptions.this_week_to_date;
  },

  get this_semi_month() {
    return intervalOptions.this_semi_month;
  },

  get this_semi_month_to_date() {
    return intervalOptions.this_semi_month_to_date;
  },

  get this_month() {
    return intervalOptions.this_month;
  },

  get this_month_to_date() {
    return intervalOptions.this_month_to_date;
  },

  get this_quarter() {
    return intervalOptions.this_quarter;
  },

  get this_quarter_to_date() {
    return intervalOptions.this_quarter_to_date;
  },

  get this_year() {
    return intervalOptions.this_year;
  },

  get this_year_to_date() {
    return intervalOptions.this_year_to_date;
  },

  get last_week() {
    return intervalOptions.last_week;
  },

  get last_semi_month() {
    return intervalOptions.last_semi_month;
  },

  get last_month() {
    return intervalOptions.last_month;
  },

  get last_quarter() {
    return intervalOptions.last_quarter;
  },

  get last_year() {
    return intervalOptions.last_year;
  },

  get past_7_days() {
    return intervalOptions.past_7_days;
  },

  get past_30_days() {
    return intervalOptions.past_30_days;
  },

  get past_60_days() {
    return intervalOptions.past_60_days;
  },

  get past_90_days() {
    return intervalOptions.past_90_days;
  },

  get past_180_days() {
    return intervalOptions.past_180_days;
  },

  get past_365_days() {
    return intervalOptions.past_365_days;
  },

  get past_4_weeks() {
    return intervalOptions.past_4_weeks;
  },

  get past_8_weeks() {
    return intervalOptions.past_8_weeks;
  },

  get past_12_weeks() {
    return intervalOptions.past_12_weeks;
  },

  get past_26_weeks() {
    return intervalOptions.past_26_weeks;
  },

  get past_52_weeks() {
    return intervalOptions.past_52_weeks;
  },

  get past_3_months() {
    return {
      key: 'past_3_months',
      label: 'Past 3 months',
      start: moment().subtract(3, 'month').startOf('month').format(dateFormats.isoDate),
      end: moment().subtract(1, 'month').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },

  get past_6_months() {
    return {
      key: 'past_6_months',
      label: 'Past 6 months',
      start: moment().subtract(6, 'month').startOf('month').format(dateFormats.isoDate),
      end: moment().subtract(1, 'month').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },

  get past_9_months() {
    return {
      key: 'past_9_months',
      label: 'Past 9 months',
      start: moment().subtract(9, 'month').startOf('month').format(dateFormats.isoDate),
      end: moment().subtract(1, 'month').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },

  get past_12_months() {
    return {
      key: 'past_12_months',
      label: 'Past 12 months',
      start: moment().subtract(12, 'month').startOf('month').format(dateFormats.isoDate),
      end: moment().subtract(1, 'month').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },
};

export const intervalsByScope = {
  get day() {
    return [
      intervals.custom,
      intervals.today,
      intervals.yesterday,
      intervals.this_week,
      intervals.this_week_to_date,
      intervals.this_semi_month,
      intervals.this_semi_month_to_date,
      intervals.this_month,
      intervals.this_month_to_date,
      intervals.this_quarter,
      intervals.this_quarter_to_date,
      intervals.this_year,
      intervals.this_year_to_date,
      intervals.last_week,
      intervals.last_semi_month,
      intervals.last_month,
      intervals.last_quarter,
      intervals.last_year,
      intervals.past_7_days,
      intervals.past_30_days,
      intervals.past_60_days,
      intervals.past_90_days,
      intervals.past_180_days,
      intervals.past_365_days,
    ];
  },

  get week() {
    return [
      intervals.custom,
      intervals.this_week,
      intervals.last_week,
      intervals.past_4_weeks,
      intervals.past_8_weeks,
      intervals.past_12_weeks,
      intervals.past_26_weeks,
      intervals.past_52_weeks,
    ];
  },

  get month() {
    return [
      intervals.custom,
      intervals.this_month,
      intervals.last_month,
      intervals.past_3_months,
      intervals.past_6_months,
      intervals.past_9_months,
      intervals.past_12_months,
    ];
  },
};
